

export const UPDATE_THEME_SETTINGS = 'UPDATE_THEME_SETTINGS';


export const updateThemeSettings = (values) =>
    ({ type: UPDATE_THEME_SETTINGS, values: values })